var locale_ar = {
    bandContent: 'محتوى الصفحة',
    bandFooter: 'الذيل',
    bandHeader: 'رأس الصفحة',
    barCodeElementContent: 'المحتوى',
    barCodeElementDisplayValue: 'القـيمة',
    barCodeElementFormat: 'البنية',
    contentHeight: 'إرتـفاع المحتوى',
    contentHeightInfo: 'يؤثر فقط على حجم واجهة المستخدم الرسومية لوضع العناصر وليس حجم الصفحة الحقيقي',
    docElementAlwaysPrintOnSamePage: 'دائما في نفس الصفحة',
    docElementBarCode: 'الباركود',
    docElementColor: 'اللون',
    docElementConditionalStyle: 'النمط المشروط',
    docElementConditionalStyleCondition: 'الشـرط',
    docElementDataSource: 'مصـدر البـيانات',
    docElementFrame: 'الإطـار',
    docElementHeight: 'الإرتـفاع',
    docElementImage: 'الصـورة',
    docElementLabel: 'إسـم',
    docElementLine: 'خـط',
    docElementPageBreak: 'فاصل صفحة',
    docElementPosition: 'الموضـع (x, y)',
    docElementPositionX: 'الموضع (x)',
    docElementPositionY: 'الموضع (y)',
    docElementPrintIf: 'إطبـع إذا',
    docElementPrintSettings: 'إعدادات الطباعة',
    docElementRemoveEmptyElement: 'إزالة عندما تكون فارغة',
    docElementRoot: 'المسـتند',
    docElementSection: 'قِـسم',
    docElementLink: 'رابـط',
    docElementSize: 'حـجم (عرض, ارتفاع)',
    docElementSpreadsheet: 'جـدول',
    docElementSpreadsheetAddEmptyRow: 'إضافة صف فارغ بالأسفل',
    docElementSpreadsheetColspan: 'كعمـود واحد',
    docElementSpreadsheetColumn: 'عمود ثابت',
    docElementSpreadsheetHide: 'إخـفاء',
    docElementWidth: 'العـرض',
    docElementStyle: 'النـمط',
    docElementTable: 'جِـدول',
    docElementText: 'نـص',
    documentProperties: 'خصائص المستند',
    documentTabClose: 'إغلاق',
    documentTabPdfLayout: 'تنسيق PDF',
    documentTabPdfPreview: 'PDF معاينة',
    documentTabXlsxDownload: 'تحميل XLSX',
    emptyPanel: 'لوحة فارغة',
    errorMsgDuplicateParameter: 'المُـعامِل موجود مٌـسبقا',
    errorMsgDuplicateParameterField: 'الحقل موجود مٌـسبقا',
    errorMsgLoadingImageFailed: 'فـشل تحميل الصورة: ${info}',
    errorMsgInvalidArray: 'قائمة غير صالحة',
    errorMsgInvalidAvgSumExpression: 'يجب أن يحتوي التعبير على حقل رقم لأحد المُـعامِلات',
    errorMsgInvalidBarCode: 'محتوى الباركود غير صالح',
    errorMsgInvalidDataSource: 'مصدر بيانات غير صالح',
    errorMsgInvalidDataSourceParameter: 'يجب أن يكون المُـعامِل من نوع قائمة',
    errorMsgInvalidDate: 'التاريخ غير صالح ، التنسيق المتوقع هو YYYY-MM-DD (أو YYYY-MM-DD hh: mm للتاريخ مع الوقت)',
    errorMsgInvalidExpression: 'تعـبير غير صـالح: ${info}',
    errorMsgInvalidExpressionFuncNotDefined: 'الدالة $ {info} غير مُـعرفة',
    errorMsgInvalidExpressionNameNotDefined: 'الإسـم ${info} غير مُـعرف',
    errorMsgInvalidLink: 'يجب أن يبدأ الرابط بـ http: // أو https: //',
    errorMsgInvalidImage: 'بيانات الصورة غير صالحة ، يجب أن تكون الصورة بتـشفير base64',
    errorMsgInvalidImageSource: 'مصدر غير صالح ، عنوان url المتوقع يبدأ بـ http: // أو https: //',
    errorMsgInvalidImageSourceParameter: 'يجب أن يكون المُـعامِل صورة أو سلسلة (يحتوي على عنوان url)',
    errorMsgInvalidMap: 'مجموعة غير صالحة',
    errorMsgInvalidNumber: 'رقم غير صالح',
    errorMsgInvalidPageSize: 'حجم الصفحة غير صالح',
    errorMsgInvalidParameterData: 'البيانات لا تتطابق مع المُـعامِل',
    errorMsgInvalidParameterName: 'يجب أن يبدأ الاسم بحرف أو شرطة سفلية ، ويجب أن يحتوي فقط على أحرف وأرقام وشُرَط سفلية (_)',
    errorMsgInvalidPattern: 'نمط غير صالح',
    errorMsgInvalidPosition: 'الموقف خارج المنطقة',
    errorMsgInvalidSize: 'العنصر خارج المنطقة',
    errorMsgInvalidTestData: 'بيانات الاختبار غير صالحة',
    errorMsgMissingData: 'بيانات مفقودة',
    errorMsgMissingDataSourceParameter: 'لم يتم العثور على معلمة مصدر البيانات',
    errorMsgMissingExpression: 'يجب تعيين التعبير',
    errorMsgMissingImage: 'الصورة المفقودة ، لم يتم تحديد ملف مصدر أو صورة',
    errorMsgMissingParameter: 'المُـعامِل غير موجود',
    errorMsgMissingParameterData: 'لم يتم العثور على بيانات المُـعامِل {info}',
    errorMsgSectionBandNotOnSamePage: 'أجزاء القسم لا تصلح في نفس الصفحة',
    errorMsgUnicodeEncodeError: 'النص يحتوي على حرف غير قابل للطباعة',
    errorMsgUnsupportedImageType: 'الصورة لا تحتوي على نوع صورة مدعوم (.jpg ، .png)',
    footer: 'ذيل الصفحة',
    footerDisplay: 'عرض',
    footerSize: 'حجم ذيل الصفحة',
    frameElementShrinkToContentHeight: 'تقليص إلى إرتفاع المحتوى',
    imageElementImage: 'ملف الصورة',
    imageElementLoadErrorMsg: 'فشل تحميل الصورة',
    imageElementSource: 'مصدر',
    header: 'رأس',
    headerDisplay: 'عرض',
    headerFooterDisplayAlways: 'دائما',
    headerFooterDisplayNotOnFirstPage: 'لا تظهر في الصفحة الأولى',
    headerSize: 'حجم الرأس',
    menuColumnAddLeft: 'إضافة عمود إلى اليسار',
    menuColumnAddRight: 'إضافة عمود إلى اليمين',
    menuColumnDelete: 'حذف العمود',
    menuAlignBottom: 'محاذاة القاع',
    menuAlignCenter: 'محاذاة المركز',
    menuAlignLeft: 'محاذاة اليسار',
    menuAlignMiddle: 'محاذاة الوسط',
    menuAlignRight: 'محاذاة اليمين',
    menuAlignTop: 'محاذاة أعلى',
    menuPreview: 'معاينة',
    menuPreviewTip: 'معاينة التقرير',
    menuRedo: 'فعل ثانية',
    menuRedoTip: 'كرر اخر امر تم التراجع عنه',
    menuRowAddAbove: 'إضافة صف أعلاه',
    menuRowAddBelow: 'إضافة صف أدناه',
    menuRowDelete: 'احذف صف',
    menuSave: 'حفظ',
    menuSaveTip: 'احفظ التقرير',
    menuToggleGrid: 'إظهار / إخفاء الشبكة',
    menuUndo: 'تراجع',
    menuUndoTip: 'التراجع عن الأمر الأخير',
    orientation: 'اتجاه',
    orientationBottom: 'الأسفل',
    orientationLandscape: 'Landscape',
    orientationLeft: 'اليسار',
    orientationPortrait: 'Portrait',
    orientationRight: 'اليمين',
    orientationTop: 'الأعلى',
    pageFormat: 'تنسيق الصفحة',
    pageFormatA4: 'DIN A4 (210 x 297 mm)',
    pageFormatA5: 'DIN A5 (148 x 210 mm)',
    pageFormatLetter: 'Letter (8.5 x 11.0 inches)',
    pageFormatUserDefined: 'أبعاد خـاصة',
    pageHeight: 'ارتفاع',
    pageMargins: 'هوامش الصفحة',
    pageWidth: 'عرض',
    parameter: 'معامل',
    parameterAddTestData: 'إضافة صف',
    parameterArrayItemType: 'نوع عنصر القائمة',
    parameterEditTestData: 'تعديل',
    parameterEditTestDataNoFields: 'لا توجد حقول محددة لهذه القائمة',
    parameterEval: 'تقييم النص',
    parameterExpression: 'التعبير',
    parameterListType: 'نوع القائمة',
    parameterName: 'الإسم',
    parameterNullable: 'قيم الفارغة',
    parameterPattern: 'نمط',
    parameterSearchPlaceholder: 'بحث المُـعاملات ...',
    parameterTestData: 'بيـانات الإختـبار',
    parameterTestDataDatePattern: 'YYYY-MM-DD',
    parameterType: 'النـوع',
    parameterTypeArray: 'قائمة',
    parameterTypeAverage: 'متوسط',
    parameterTypeBoolean: 'منطقية',
    parameterTypeDate: 'تاريخ',
    parameterTypeImage: 'صورة',
    parameterTypeMap: 'مجموعة',
    parameterTypeNumber: 'رقم',
    parameterTypeSimpleArray: 'قائمة بسيطة',
    parameterTypeString: 'نص',
    parameterTypeSum: 'مجموع',
    parameters: 'المعاملات',
    parametersDataSource: 'معاملات مصدر البيانات',
    patternCurrencySymbol: 'رمز العملة',
    patternDate1: 'يوم.شهر.سنة ، على سبيل المثال 1980/06/01',
    patternDate2: 'يوم.شهر.سنة (مكون من رقمين) ، ساعة (24 ساعة): دقيقة ، على سبيل المثال 1.6.80 ، 14:30',
    patternDate3: 'يوم / شهر / سنة (اختصار الشهر) ، على سبيل المثال 1 / يونيو / 1980',
    patternDate4: 'الشهر / اليوم / السنة (اليوم والشهر مع ظهور صفر في خانة واحدة) ، على سبيل المثال 1980/06/01',
    patternLocale: 'نمط اللغة',
    patternNumber1: 'فواصـل الآلاف',
    patternNumber2: 'عرض العلامة العشرية متبوعة بـ 3 منازل عشرية',
    patternNumber3: 'عرض العلامة العشرية متبوعة بحد أدنى 2 والحد الأقصى 4 منازل عشرية',
    patternNumber4: 'عرض ألف فاصل وكسر عشري متبوعًا بمنازل عشرية',
    patternNumber5: 'إظهار رمز العملة أمام الرقم',
    patternSeparatorDates: '--- أنماط التاريخ ---',
    patternSeparatorNumbers: '--- أنماط الأرقام ---',
    select: 'تحديد...',
    style: 'نمط الشكل',
    styleAlignment: 'المحاذاة',
    styleBackgroundColor: 'لون الخلفية',
    styleBold: 'بالخط العريض',
    styleBorder: 'الحدود',
    styleBorderAll: 'الحدود',
    styleBorderColor: 'لون الحدود',
    styleBorderWidth: 'عرض الحدود',
    styleFont: 'الخط',
    styleFontSizeUnit: 'pt',
    styleHAlignmentCenter: 'وسط',
    styleHAlignmentLeft: 'يسار',
    styleHAlignmentJustify: 'ملأ السطر',
    styleHAlignmentRight: 'يمين',
    styleItalic: 'مائل',
    styleLineSpacing: 'تباعد الأسطر',
    styleName: 'اسم',
    styleNone: 'لا شيء',
    stylePadding: 'حشوة',
    styleStrikethrough: 'يتوسطه',
    styleTextColor: 'لون الخط',
    styleTextStyle: 'نمط النص',
    styleUnderline: 'تحته خط',
    styleVAlignmentBottom: 'الأسفل',
    styleVAlignmentMiddle: 'وسط',
    styleVAlignmentTop: 'أعلى',
    styles: 'الأنماط',
    tableElementAlternateBackgroundColor: 'لون الخلفية البديل',
    tableElementBorderFrame: 'الإطار',
    tableElementBorderFrameRow: 'الإطار والصف',
    tableElementBorderGrid: 'شبكة',
    tableElementBorderNone: 'لا شيء',
    tableElementBorderRow: 'صف',
    tableElementColumns: 'أعمدة',
    tableElementColspan: 'كعمـود واحد',
    tableElementContentRows: 'صفوف المحتوى',
    tableElementGroupExpression: 'تعبير المجموعة',
    tableElementRepeatHeader: 'كرر الرأس',
    textElementContent: 'نص',
    textElementEval: 'ترقـية',
    textElementPattern: 'نمط'
};

export default locale_ar;



// WEBPACK FOOTER //
// ./src/i18n/locale_ar_ly.js